<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <TwoButtonDialog
              ref="sendButton"
              :outlined="true"
              :rounded="false"
              :icon="'add_a_photo'"
              :btn-text="$t('display/elevator:edit.labels.functions-tab.snapshot')"
              color="primary"
              :dialog-title="$t('display/elevator:edit.dialog.camera-title')"
              :dialog-text="$t('display/elevator:edit.dialog.camera-text')"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('display/elevator:edit.dialog.send')"
              @clickedButton1="$refs.sendButton.showDialog = false"
              @clickedButton2="makeSnapshot()"
          />
          <v-btn
            color="primary"
            class="mr-3 mb-3 mb-md-0 white--text"
            outlined
            elevation="0"
            @click="loadPhotos"
          >
            <v-icon class="mr-2">loop</v-icon>
            {{$t('display/elevator:edit.labels.camera-tab.load-camera-images')}}
          </v-btn>
          <v-select
              class="mt-3"
              :items="photos"
              item-text="name"
              item-value="id"
              :menu-props="{bottom: true, offsetY: true}"
              v-model="selectedPhoto"
              outlined
              clearable
              @change="updatePhoto"
              :label="$t('common:image_plural')"
          />
        </v-col>

        <v-col cols="12" class="camera-container">
          <v-img
            :src="image"
            />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ElevatorService from '@/modules/display/services/elevator-service';
import Utils from '@/modules/core/services/utils';
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";

export default {
  name: "CameraTab",
  components: {
    TwoButtonDialog
  },
  data() {
    return {
      photos: [],
      selectedPhoto: null,
      image: null
    }
  },
  methods: {
    makeSnapshot() {
      ElevatorService.sendCommandWithBody(
          this.$store.state.display.elevatorForm.elevator.id,
          {'cmd' : 'getimage'},
          () => {
            Utils.showSuccessSnackbar(this.$t('display/elevator:edit.dialog.success-send'));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('display/elevator:edit.dialog.problem-happened'));
          }
      );
      this.$refs.sendButton.showDialog = false;
    },

    updatePhoto() {
      this.image = null;
      if (this.selectedPhoto) {
        ElevatorService.loadSelectedImage(
          this.selectedPhoto,
          (response) => {
            this.image = 'data:image/jpeg;base64,' + response.data;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:image')}));
          }
        );
      }
    },

    loadPhotos() {
      this.photos = [];
      ElevatorService.loadImagesFromElevator(
        this.$store.state.display.elevatorForm.elevator.id,
        (response) => {
          response.data.forEach((photo) => {
            this.photos.push({
              id: photo[0],
              name: photo[1]
            });
          });

          if (this.photos.length > 0) {
            Utils.showSuccessSnackbar(this.$t('snackbar:load-success', {name: this.$t('common:image_plural')}));
          } else {
            Utils.showWarningSnackbar(this.$t('display/elevator:edit.snackbar.there-ara-no-photos'))
          }
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:image_plural')}));
        }
      )
    },

    reset() {
      this.photos = [];
      this.selectedPhoto = null;
      this.image = null;
    }
  }
}
</script>

<style scoped>
.camera-container {
  min-height: 600px;
}

</style>
